import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";
import DualListBox from "../../../duallistBox";
import Cookies from "js-cookie";
import { useUserPermissions } from "../../../UserPermissionsContext";

type Permission = { id: number; name: string };

type Admin = {
  permissions: Array<number>;
  ticket_type: string | null;
  ticket_type_id: number;
};

const EditTypeOfTicket = () => {
  const routes = all_routes;
  const location = useLocation();
  const { id } = location.state || {};
  console.log(id);
  const navigate = useNavigate();
  const [chosenPermissions, setChosenPermissions] = useState<Permission[]>([]);
  const [permissions, setPermissions] = useState<Permission[]>([]);
  const jwtToken = Cookies.get("authToken");
  const { userPermissions, webApi } = useUserPermissions();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState({});
  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject
    );
  };
  
  const [newAdmin, setNewAdmin] = useState<Admin>({
    ticket_type: null,
    ticket_type_id: 0,
    permissions: [],
  });

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  const fetchProviderData = async (id: string) => {
    const response = await fetch(`${webApi}/wizklub/type_of_tickets/${id}`, options);
    return await response.json();
  };

  const fetchPermissionsData = async () => {
    const resposne = await fetch(
      `${webApi}/user/get_permissions_dropdown/`,
      options
    );
    return await resposne.json();
  };

  const fetchData = async () => {
    setIsLoading(true);
    try {
      if (id) {
        const [providerData, permissionsData] = await Promise.all([
          fetchProviderData(id),
          fetchPermissionsData(),
        ]);
        setData(providerData);
        setNewAdmin({
          ticket_type: providerData.ticket_type,
          ticket_type_id: providerData.ticket_type_id,
          permissions: providerData.permissions,
        });
        const initialChosenPermissions = permissionsData.results.filter(
          (permission: { id: any }) =>
            providerData.permissions.includes(permission.id)
        );
        const remainingPermissions = permissionsData.results.filter(
          (permission: { id: any }) =>
            !providerData.permissions.includes(permission.id)
        );
        setChosenPermissions(initialChosenPermissions);
        setPermissions(remainingPermissions);
      } else {
        console.error("ID is undefined");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePermissionsChange = (selected: Permission[]) => {
    setNewAdmin({
      ...newAdmin,
      permissions: selected.map((permission) => permission.id),
    });
  };

  useEffect(() => {
    if (!checkPermission("change", "Can change ticket type")) {
      Cookies.remove("authToken");
      navigate("/login");
    } else {
      fetchData();
    }
  }, [userPermissions]);
  

  const updateData = async () => {
    const requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify(newAdmin),
    };
    const url = `${webApi}/wizklub/type_of_tickets/${id}/`;
    const response = await fetch(url, requestOptions);
    if (!response.ok) {
      const errorData = await response.json();

      throw new Error("Network response was not ok");
    }
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      await updateData();
      navigate(routes.TypeOfTicket);
    } catch (error) {}
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setNewAdmin({ ...newAdmin, [name]: value || null });
  };

  useEffect(() => {
    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    const forms = document.querySelectorAll(
      ".needs-validation"
    ) as NodeListOf<HTMLFormElement>;

    // Loop over them and prevent submission
    Array.from(forms).forEach((form) => {
      form.addEventListener(
        "submit",
        (event) => {
          if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
          }

          form.classList.add("was-validated");
        },
        false
      );
    });
  }, []);
  return (
    <div>
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">Edit Ticket Type</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to={routes.TypeOfTicket}>Ticket Type</Link>
                  </li>
                  <li className="breadcrumb-item active">Edit Ticket Type</li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}

          {/* Row */}
          <div className="row justify-content-center">
            <div className="col-sm-12 d-flex justify-content-center">
              {/* Add Group */}
              <div
                className="card"
                style={{
                  width: "70%",
                  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                  borderRadius: "10px",
                }}
              >
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div className="form-group mb-3" style={{ width: "35%" }}>
                      <label className="form-label">Ticket Type Name</label>
                      <input
                        type="text"
                        className="form-control"
                        name="ticket_type"
                        placeholder="Ticket Type Name"
                        onChange={handleInputChange}
                        value={newAdmin.ticket_type || ""}
                      />
                    </div>
                    <div className="modal-footer">
                      <Link
                        className="btn btn-primary"
                        type="submit"
                        to={routes.ticketStatus}
                        style={{
                          backgroundColor: "lightcoral",
                          color: "white",
                          marginRight:"5px"
                        }}
                      >
                        Cancel
                      </Link>
                      <button className="btn btn-primary" type="submit">
                        Save
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              {/* /Add Group */}
            </div>
          </div>
          {/* /Row */}
        </div>
      </div>
    </div>
  );
};

export default EditTypeOfTicket;
